import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import RealEstateHero from './components/RealEstateHero';
import RealEstatePainPoints from './components/RealEstatePainPoints';
import RealEstateHowHelps from './components/RealEstateHowHelps';
import RealEstateExamples from './components/RealEstateExamples';
import RealEstateHowItWorks from './components/RealEstateHowItWorks';
import RealEstateBenefits from './components/RealEstateBenefits';
import RealEstateFAQ from './components/RealEstateFAQ';
import RealEstateCTA from './components/RealEstateCTA';

export default function RealEstatePage() {
  return (
    <>
      <title>AI Ads for Real Estate | Get More Listings & Leads | AdForge</title>
      <meta
        name="description"
        content="AI ads for real estate that actually get listings and leads. AdForge creates Facebook ads for real estate agents, Google ads, and Instagram ads in minutes. No marketing experience needed. Try free."
      />
      <meta
        name="keywords"
        content="AI ads for real estate, real estate advertising, facebook ads for real estate, google ads for real estate agents, real estate lead generation, realtor ad generator"
      />
      <link rel="canonical" href="https://adforge.ai/ai-ads-for-real-estate" />
      <meta name="Last-modified" content={new Date().toISOString().split('T')[0]} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content="AI Ads for Real Estate | AdForge — Get More Listings & Leads" />
      <meta
        property="og:description"
        content="AI-powered real estate advertising that fills your pipeline. Build Facebook ads for real estate, Google ads, and more in minutes. No experience needed."
      />
      <meta property="og:url" content="https://adforge.ai/ai-ads-for-real-estate" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="AI Ads for Real Estate | AdForge" />
      <meta
        name="twitter:description"
        content="Stop wasting money on ads that don't get leads. AdForge builds AI ads for real estate agents in minutes. Free to start."
      />

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'AI Ads for Real Estate — AdForge',
        description:
          'AdForge creates AI ads for real estate agents, brokerages, and property managers. Generate Facebook ads and Google ads for listings, buyer leads, and seller leads in minutes.',
        url: 'https://adforge.ai/ai-ads-for-real-estate',
        mainEntity: {
          '@type': 'SoftwareApplication',
          name: 'AdForge AI Ad Generator for Real Estate',
          applicationCategory: 'BusinessApplication',
          operatingSystem: 'Web',
          offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'USD',
            description: 'Free plan available — no credit card required',
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '1870',
          },
        },
      })}</script>

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Do I need marketing experience to use AI ads for real estate?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'No. AdForge is built for agents with zero marketing experience. You answer a few simple questions about your listing or target market and the AI does the rest — writing the copy, generating images, and formatting ads for Facebook, Instagram, and Google.',
            },
          },
          {
            '@type': 'Question',
            name: 'How much does real estate advertising with AdForge cost?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'AdForge is free to start. Paid plans start at $29/month. Your actual Facebook or Google ad spend is separate and set by you directly in the ad platform.',
            },
          },
          {
            '@type': 'Question',
            name: 'What types of real estate professionals can use AdForge?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'AdForge works for all real estate professionals: buyer\'s agents, listing agents, brokerages, property managers, mortgage brokers, new development sales teams, and commercial real estate agents.',
            },
          },
          {
            '@type': 'Question',
            name: 'How fast can I create real estate ads with AdForge?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Most agents generate their first complete ad package — including copy, headlines, hooks, and AI images — in under 3 minutes.',
            },
          },
          {
            '@type': 'Question',
            name: 'Can I create ads for both buyer leads and seller leads?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Yes. AdForge lets you create targeted ads for any goal — promoting a specific listing, generating seller leads with a home valuation offer, attracting first-time buyers, or building your personal brand as a local expert.',
            },
          },
        ],
      })}</script>

      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <RealEstateHero />
          <RealEstatePainPoints />
          <RealEstateHowHelps />
          <RealEstateExamples />
          <RealEstateHowItWorks />
          <RealEstateBenefits />
          <RealEstateFAQ />
          <RealEstateCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}
